import Command from '@/api/master/Command'
import Functions from '@/functions'

export default {
  namespaced: true,
  state: {
    total: 0,
    data: [],
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data.data
      state.total = data.total
    },
  },
  actions: {
    datatable({commit}, params) {
      return Command.datatable(params).then(res => {
        commit('SET_DATA', res.data.message)
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    detail({}, id) {
      return Command.detail(id).then(res => {
        const {data} = res.data.message
        return data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    store({}, data) {
      return Command.store(data).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    update({}, {id, ...data}) {
      return Command.update(id, data).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    delete({}, id) {
      return Command.delete(id).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    }
  },
  getters: {}
}
